<div class="aggregated-amounts">
  <div class="mat-subheading-2" fxLayout fxLayoutGap="4px" fxLayoutAlign="start cetner">
    <mat-icon>whatshot</mat-icon>
    <div>
      <span>最新値</span>
      <span class="date-range">
        {{ criteriaFrom$ | async | date: 'yyyy-MM-dd' }}
        ~
        {{ criteriaTo$ | async | date: 'yyyy-MM-dd' }}
        期間の最新データ /
      {{ criteriaFromBehindOneDay$ | async | date: 'yyyy-MM-dd' }} 時点との比較</span>
    </div>
    <mat-icon class="help" matTooltip="選択期間内に取得できた最新のTwitter、Facebook、Instagramフォロワー数、Instagramにおけるハッシュタグ投稿数です。">
    help_outline</mat-icon>
    <app-csv-download [id]="csvIdRecent" [fileName]="csvFileNameRecent" [csv]="csvDataRecent$ | async"
    [loading]="csvLoadingRecent$ | async" [artist]="selectedArtist$ | async"></app-csv-download>
  </div>
  <div fxLayout="row wrap" fxLayoutGap="16px grid">
    @if (!(loading$ | async)) {
      @for (twitterFollower of twitterFollowers$ | async; track twitterFollower; let i = $index) {
        <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
          <app-aggregated-amounts-twitter-follower [url]="twitterFollower.url">
          </app-aggregated-amounts-twitter-follower>
        </div>
      }
    } @else {
      <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
        <app-aggregated-amount-item name="Twitter（ - ）" icon="./assets/twitter.png" [amount]="" unit="フォロワー数" [rate]=""
          [link]="" [hasAmount]="false" [loading]="loading$ | async" help="Twitter のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
          [dataCollections]="dataCollections$ | async" [dataCollectLoading]="dataCollectLoading$ | async">
        </app-aggregated-amount-item>
      </div>
      <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
        <app-aggregated-amount-item name="Twitter（ - ）" icon="./assets/twitter.png" [amount]="" unit="フォロワー数" [rate]=""
          [link]="" [hasAmount]="false" [loading]="loading$ | async" help="Twitter のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
          [dataCollections]="dataCollections$ | async" [dataCollectLoading]="dataCollectLoading$ | async">
        </app-aggregated-amount-item>
      </div>
    }
    @if (!(loading$ | async)) {
      @for (facebookFollower of facebookFollowers$ | async; track facebookFollower; let i = $index) {
        <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
          <app-aggregated-amounts-facebook-follower [url]="facebookFollower.url">
          </app-aggregated-amounts-facebook-follower>
        </div>
      }
    } @else {
      <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
        <app-aggregated-amount-item name="Facebook（ - ）" icon="./assets/facebook.png" [amount]="" unit="フォロワー数" [rate]=""
          [link]="" [hasAmount]="false" [loading]="loading$ | async" help="Facebook のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
          [dataCollections]="dataCollections$ | async" [dataCollectLoading]="dataCollectLoading$ | async">
        </app-aggregated-amount-item>
      </div>
      <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
        <app-aggregated-amount-item name="Facebook（ - ）" icon="./assets/facebook.png" [amount]="" unit="フォロワー数" [rate]=""
          [link]="" [hasAmount]="false" [loading]="loading$ | async" help="Facebook のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
          [dataCollections]="dataCollections$ | async" [dataCollectLoading]="dataCollectLoading$ | async">
        </app-aggregated-amount-item>
      </div>
    }

    @if (!(loading$ | async)) {
      @for (instagramFollower of instagramFollowers$ | async; track instagramFollower; let i = $index) {
        <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
          <app-aggregated-amounts-instagram-followers-count [url]="instagramFollower.url">
          </app-aggregated-amounts-instagram-followers-count>
        </div>
      }
    } @else {
      <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
        <app-aggregated-amount-item name="Instagram（ - ）" icon="./assets/instagram.png" [amount]="" unit="フォロワー数" [rate]=""
          [link]="" [hasAmount]="false" [loading]="loading$ | async" help="Instagram のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
          [dataCollections]="dataCollections$ | async" [dataCollectLoading]="dataCollectLoading$ | async">
        </app-aggregated-amount-item>
      </div>
      <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
        <app-aggregated-amount-item name="Instagram（ - ）" icon="./assets/instagram.png" [amount]="" unit="フォロワー数" [rate]=""
          [link]="" [hasAmount]="false" [loading]="loading$ | async" help="Instagram のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
          [dataCollections]="dataCollections$ | async" [dataCollectLoading]="dataCollectLoading$ | async">
        </app-aggregated-amount-item>
      </div>
    }

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-instagram-hashtag-count></app-aggregated-amounts-instagram-hashtag-count>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-line-follower></app-aggregated-amounts-line-follower>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-youtube-channel-subscribers-count>
      </app-aggregated-amounts-youtube-channel-subscribers-count>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-spotify-follower></app-aggregated-amounts-spotify-follower>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-tiktok-follower></app-aggregated-amounts-tiktok-follower>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-newsletter-subscriber-count></app-aggregated-amounts-newsletter-subscriber-count>
    </div>
  </div>

  <div class="spacer-fixed-vertical-48"></div>

  <div class="mat-subheading-2 aggregated-amounts-period" fxLayout fxLayoutGap="4px">
    <mat-icon>date_range</mat-icon>
    <div>
      <span>期間集計値</span>
      <span class="date-range">
        {{ criteriaFrom$ | async | date: 'yyyy-MM-dd' }}
        ~
        {{ criteriaTo$ | async | date: 'yyyy-MM-dd' }}
        期間の集計データ /
        {{ criteriaPreviousFrom$ | async | date: 'yyyy-MM-dd' }}
        ~
        {{ criteriaPreviousTo$ | async | date: 'yyyy-MM-dd' }}
        との比較
      </span>
    </div>
    <mat-icon class="help" matTooltip="選択された期間内の合計数と比較値です。">help_outline</mat-icon>
    <app-csv-download [id]="csvIdTotal" [fileName]="csvFileNameTotal" [csv]="csvDataTotal$ | async"
    [loading]="csvLoadingTotal$ | async" [artist]="selectedArtist$ | async"></app-csv-download>
  </div>

  <div fxLayout="row wrap" fxLayoutGap="16px grid">
    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-physical-shipment-count></app-aggregated-amounts-physical-shipment-count>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-pos-physical-estimate></app-aggregated-amounts-pos-physical-estimate>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-streams></app-aggregated-amounts-streams>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-download-unit></app-aggregated-amounts-download-unit>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-umhp-pageview></app-aggregated-amounts-umhp-pageview>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-umhp-userview></app-aggregated-amounts-umhp-userview>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-google-search-count></app-aggregated-amounts-google-search-count>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-special-umhp-pageview></app-aggregated-amounts-special-umhp-pageview>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-special-umhp-userview></app-aggregated-amounts-special-umhp-userview>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-umstore-pageview></app-aggregated-amounts-umstore-pageview>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-udiscover-pageview></app-aggregated-amounts-udiscover-pageview>
    </div>

    @for (wiki of (selectedArtist$ | async)?.wikipedia.urls; track wiki; let i = $index) {
      @if (isZero(i) || wiki !== '') {
        <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
          <app-aggregated-amounts-wikipedia-pageview [wikiUrl]="wiki">
          </app-aggregated-amounts-wikipedia-pageview>
        </div>
      }
    }

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-twitter-keywords-count></app-aggregated-amounts-twitter-keywords-count>
    </div>

    <div fxFlex="1 1 20%" fxFlex.md="25%" fxFlex.sm="1 1 50%">
      <app-aggregated-amounts-shazams></app-aggregated-amounts-shazams>
    </div>
  </div>
</div>

